/**
 * Created by Ewald Stamp (ewald.stamp@netmills.de) on 19.02.15.
 */

angular
  .module('farmnet.partner.externalAccounts')
  .directive(
    'settingsExternalAccounts',
    function SettingsExternalAccountsDirective() {
      'use strict';

      return {
        restrict: 'E',
        scope: {
          group: '@'
        },
        templateUrl: require('./SettingsExternalAccountsView.html'),
        controller: 'SettingsExternalAccountsController'
      };
    }
  );
